module.exports = __webpack_public_path__ + "img/lugo.952ecea0.jpg";